import { useTranslation } from "react-i18next";
import React from "react";
import "./style.scss";
import { CloseOrangeIcon } from "../icons/svg";

interface AlertProps {
  message?: string;
  onClose?: () => void;
}
function LoginAlert({ message = "", onClose = () => {} }: AlertProps) {
  const { t } = useTranslation();
  return (
    <div className="default-alert">
      <div className="war-not font-size-14 line-height-20 font-weight-5">
        {t("Cảnh báo", "Cảnh báo")}
      </div>
      <span className="font-size-14 line-height-20 font-weight-5 flex-1 text-left">
        {message || "Có lỗi xảy ra"}
      </span>
      <div className="close-btn pointer mr-1" onClick={onClose}>
        <CloseOrangeIcon />
      </div>
    </div>
  );
}

export default LoginAlert;
